import { Chip } from "@mui/material";
import GridListItem from "components/common/grid/GridListItem";
import React from "react";

const MagneticProcedures = ({ newProfileInfo }) => {
  return (
    <GridListItem
      title="NEED MAGNET DURING PROCEDURES"
      subTitle={
        newProfileInfo?.need_magnet_during_procedures !== null ? (
          <Chip
            color={
              newProfileInfo?.need_magnet_during_procedures
                ? "secondary"
                : "default"
            }
            label={
              <span className="d-flex align-items-center text-normal">
                {newProfileInfo?.need_magnet_during_procedures ? "YES" : "No"}
              </span>
            }
            style={{ padding: "0px 5px", marginBottom: 5 }}
          />
        ) : (
          "—"
        )
      }
      size="3"
    />
  );
};

export default MagneticProcedures;
